import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 吃瓜爆料',
    description: '吃瓜爆料品牌介绍、发展历程与联系方式',
    url: 'https://www.chiguabaoliao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜爆料',
      url: 'https://www.chiguabaoliao.com',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.chiguabaoliao.com' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜爆料',
    url: 'https://www.chiguabaoliao.com',
    description: '吃瓜爆料 - 娱乐八卦、明星动态、社会热点爆料第一站',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '朝阳区建国路88号',
      addressLocality: '北京',
      addressRegion: '北京',
      postalCode: '100022',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-6666',
      contactType: 'customer service',
      email: 'contact@chiguabaoliao.com',
    },
    sameAs: [
      'https://weibo.com/chiguabaoliao',
      'https://www.zhihu.com/org/chiguabaoliao',
    ],
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '吃瓜爆料是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜爆料是一个专注于娱乐八卦、明星动态、社会热点爆料的资讯内容平台，为网民提供最新、最全、最快的一手爆料内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系吃瓜爆料的编辑团队？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过电子邮件 contact@chiguabaoliao.com 或客服电话 400-888-6666 联系我们的编辑团队。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜爆料的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来自专业编辑团队采编、网友投稿以及合作的媒体渠道，所有内容均经过严格的审核流程，确保信息的真实性和准确性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在吃瓜爆料上投稿？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以将爆料内容发送至我们的投稿邮箱 tips@chiguabaoliao.com，我们的编辑团队会尽快审核并回复您。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 吃瓜爆料"
        description="吃瓜爆料品牌介绍、发展历程与联系方式。了解吃瓜爆料的使命、团队和服务。"
        keywords="吃瓜爆料,关于我们,品牌介绍,联系方式,吃瓜爆料网"
        canonicalUrl="https://www.chiguabaoliao.com/about"
        jsonLd={[aboutJsonLd, breadcrumbJsonLd, orgJsonLd, faqJsonLd]}
      />

      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <section className="mb-16">
          <div className="relative rounded-2xl overflow-hidden aspect-[21/9] mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20modern%20office%20interior%20with%20creative%20team%20collaboration%2C%20editorial%20newsroom%20atmosphere%2C%20soft%20natural%20lighting%2C%20minimal%20design%2C%20warm%20coral%20and%20beige%20tones%2C%20professional%20yet%20inviting%20workspace&width=1600&height=700&seq=about-hero-bg&orientation=landscape"
              alt="吃瓜爆料团队"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8">
              <h1 className="text-white font-heading text-3xl md:text-4xl font-bold mb-2">关于吃瓜爆料</h1>
              <p className="text-white/80 text-sm md:text-base">做最懂你的吃瓜平台</p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">品牌介绍</h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  吃瓜爆料成立于2020年，是国内领先的娱乐资讯内容平台。我们专注于为网民提供最新、最全、最热门的娱乐八卦、明星动态、社会热点等爆料内容。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  "吃瓜"一词源于中国网络文化，形象地表达了网民围观热点事件、消费娱乐资讯的场景。吃瓜爆料以此为名，致力于成为广大网友"吃瓜"的第一选择——让每一位用户都能在这里找到最热门的谈资，了解最劲爆的内幕。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  我们的编辑团队由资深娱乐记者、新媒体运营专家和数据分析师组成，全天候追踪娱乐圈最新动态，确保每一条爆料都经过严格的核实和编辑，为用户提供真实、有趣、有价值的阅读体验。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">我们的使命</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="p-5 rounded-xl bg-primary-50/50 border border-primary-100/50">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                      <i className="ri-speed-line text-lg"></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-1">快速</h3>
                    <p className="text-xs text-foreground-600">第一时间追踪热点，让您比别人更快一步了解最新动态</p>
                  </div>
                  <div className="p-5 rounded-xl bg-accent-50/50 border border-accent-100/50">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-3">
                      <i className="ri-shield-check-line text-lg"></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-1">真实</h3>
                    <p className="text-xs text-foreground-600">严格审核每一条信息，确保内容真实可靠</p>
                  </div>
                  <div className="p-5 rounded-xl bg-secondary-50/50 border border-secondary-100/50">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 mb-3">
                      <i className="ri-heart-line text-lg"></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-1">有趣</h3>
                    <p className="text-xs text-foreground-600">用最生动的语言讲最劲爆的瓜，让阅读充满乐趣</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">发展历程</h2>
                <div className="space-y-4">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-16 text-right">
                      <span className="text-primary-500 font-heading font-bold text-lg">2020</span>
                    </div>
                    <div className="flex-1 pb-4 border-l-2 border-primary-200 pl-4">
                      <h4 className="font-heading font-semibold text-foreground-900">平台创立</h4>
                      <p className="text-sm text-foreground-600 mt-1">吃瓜爆料正式上线，以娱乐八卦为核心内容，迅速获得用户关注</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-16 text-right">
                      <span className="text-primary-500 font-heading font-bold text-lg">2021</span>
                    </div>
                    <div className="flex-1 pb-4 border-l-2 border-primary-200 pl-4">
                      <h4 className="font-heading font-semibold text-foreground-900">内容拓展</h4>
                      <p className="text-sm text-foreground-600 mt-1">新增社会热点、综艺娱乐等多个内容板块，月活跃用户突破500万</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-16 text-right">
                      <span className="text-primary-500 font-heading font-bold text-lg">2023</span>
                    </div>
                    <div className="flex-1 pb-4 border-l-2 border-primary-200 pl-4">
                      <h4 className="font-heading font-semibold text-foreground-900">品牌升级</h4>
                      <p className="text-sm text-foreground-600 mt-1">完成品牌全面升级，建立专业编辑团队，成为行业领先的爆料内容平台</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-16 text-right">
                      <span className="text-primary-500 font-heading font-bold text-lg">2026</span>
                    </div>
                    <div className="flex-1 pl-4">
                      <h4 className="font-heading font-semibold text-foreground-900">全新启航</h4>
                      <p className="text-sm text-foreground-600 mt-1">网站全面改版升级，打造更优质的阅读体验，开启"吃瓜"新时代</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1 space-y-6">
              <div className="p-6 rounded-xl bg-background-100/70 border border-background-200/70">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-contacts-line text-primary-500"></i>
                  </div>
                  联系方式
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm text-foreground-800 font-medium">contact@chiguabaoliao.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                      <i className="ri-phone-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">客服电话</p>
                      <p className="text-sm text-foreground-800 font-medium">400-888-6666</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-500">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">公司地址</p>
                      <p className="text-sm text-foreground-800 font-medium">北京市朝阳区建国路88号</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                      <i className="ri-time-line"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">工作时间</p>
                      <p className="text-sm text-foreground-800 font-medium">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-accent-50/50 border border-accent-200/50">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4">常见问题</h3>
                <div className="space-y-3">
                  <details className="group">
                    <summary className="text-sm font-medium text-foreground-800 cursor-pointer hover:text-primary-500 transition-colors list-none flex items-center justify-between">
                      吃瓜爆料是什么？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="text-xs text-foreground-600 mt-2 ml-0 pl-0 leading-relaxed">
                      吃瓜爆料是一个专注于娱乐八卦、明星动态、社会热点爆料的资讯内容平台。
                    </p>
                  </details>
                  <details className="group">
                    <summary className="text-sm font-medium text-foreground-800 cursor-pointer hover:text-primary-500 transition-colors list-none flex items-center justify-between">
                      如何联系编辑团队？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="text-xs text-foreground-600 mt-2 ml-0 pl-0 leading-relaxed">
                      您可以通过电子邮件 contact@chiguabaoliao.com 或客服电话 400-888-6666 联系我们。
                    </p>
                  </details>
                  <details className="group">
                    <summary className="text-sm font-medium text-foreground-800 cursor-pointer hover:text-primary-500 transition-colors list-none flex items-center justify-between">
                      内容来源是什么？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="text-xs text-foreground-600 mt-2 ml-0 pl-0 leading-relaxed">
                      内容来自专业编辑团队采编、网友投稿以及合作媒体渠道，经过严格审核确保真实性。
                    </p>
                  </details>
                  <details className="group">
                    <summary className="text-sm font-medium text-foreground-800 cursor-pointer hover:text-primary-500 transition-colors list-none flex items-center justify-between">
                      如何投稿？
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="text-xs text-foreground-600 mt-2 ml-0 pl-0 leading-relaxed">
                      将爆料内容发送至 tips@chiguabaoliao.com，编辑团队会尽快审核回复。
                    </p>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mb-16">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-2">行业口碑</h2>
            <p className="text-foreground-500 text-sm">来自用户和行业的认可</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="text-3xl font-heading font-bold text-primary-500 mb-1">500万+</div>
              <p className="text-xs text-foreground-600">月活跃用户</p>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="text-3xl font-heading font-bold text-accent-500 mb-1">10万+</div>
              <p className="text-xs text-foreground-600">原创爆料文章</p>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="text-3xl font-heading font-bold text-primary-500 mb-1">98%</div>
              <p className="text-xs text-foreground-600">用户满意度</p>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="text-3xl font-heading font-bold text-accent-500 mb-1">50+</div>
              <p className="text-xs text-foreground-600">合作媒体伙伴</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}